import React, { useEffect } from "react";

const RightSideModal = ({ isOpen, onClose, title, children }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="right-modal__overlay">
      {/* Backdrop */}
      <div className="right-modal__backdrop" onClick={onClose} />

      {/* Modal Content */}
      <div
        className={`right-modal__content ${isOpen ? "right-modal__open" : ""}`}
      >
        {/* Header */}
        <div className="right-modal__header">
          <h2 className="right-modal__title">{title || "Modal Title"}</h2>
          <button onClick={onClose} className="right-modal__close-btn">
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>

        {/* Body */}
        <div className="right-modal__body">{children}</div>
      </div>
    </div>
  );
};

export default RightSideModal;
